import { Theme } from "@mui/material/styles";

export const uploadBox = (theme: Theme, ownerState?: { fontSize?: string; fontWeight?: number; isError: boolean }) => {
    const {
        palette: { error },
    } = theme;
    const { isError } = ownerState;
    return {
        display: "flex",
        alignItems: "center",
        justifyItems: "center",
        flexDirection: "column",
        textAlign: "center",
        gap: 1,
        border: "2px dashed #d3d3d3",
        padding: 2,
        mt: 1,
        "&.MuiBox-root:nth-child(1)": {
            display: "flex",
            alignItems: "center",
            justifyItems: "center",
            gap: "10px",
        },
        ...(isError && { border: `2px solid ${error.main}` }),
    };
};

export const typography = (theme: Theme, ownerState?: { fontSize?: string; fontWeight?: number; isError?: boolean }) => {
    const fontSize = ownerState?.fontSize || "1rem";
    const fontWeight = ownerState?.fontWeight || 100;

    const {
        palette: { error },
    } = theme;
    const  isError = ownerState?.isError;

    return {
        fontSize,
        fontWeight,
        ...(isError && { color: error.main }),
    };
};

export const box = (theme: Theme, ownerState?: { height?: number | string; flexDirection?: string; gap?: number }) => {
    const height = ownerState?.height || "100%";
    const gap = ownerState?.gap || 0;
    const flexDirection = ownerState?.flexDirection || "column";

    return {
        display: "flex",
        alignItems: "center",
        justifyItems: "center",
        textAlign: "center",
        height: height,
        gap: gap,
        flexDirection: flexDirection,
        // "&.MuiBox-root:nth-child(1)": {
        //     display: "flex",
        //     alignItems: "center",
        //     justifyItems: "center",
        //     gap: "10px",
        // },
        "& img": {
            width: "100%",
            height: "100%",
        },
    };
};
